module.exports = __webpack_public_path__ + "img/favour.2d815cd0.jpeg";